import React from 'react';
import martrimonyLogo from '@/common/assets/images/LogoHeaer.png';
import styles from './index.module.less';

const Terms = () => {
  return (
    <div
      className={styles.maincontainer}
      // style={{
      //   paddingTop: '0px',
      //   paddingLeft: '0px',
      //   paddingRight: '0px',
      //   paddingBottom: '0px'
      // }}
    >
      <div className={styles.headerload}>
        <img
          src={martrimonyLogo}
          alt="matrimony logo"
          className={styles.logostyles}
        />
      </div>
      <div
        className={styles.cookieRow}
        // style={{
        //   display: 'flex',
        //   flexDirection: 'row',
        //   gap: '16px'
        //   // marginTop: '8px',
        //   // marginRight: '8px'
        // }}
      >
        <div className={styles.cookie}>
          <div className={styles.bgleft}></div>
        </div>
        <div className={styles.cookiecontainer}>
          <div className={styles.cookie_right}>
            <div className={styles.listview}>
              <h4>Terms and Conditions</h4>

              <h6>Introduction</h6>
              <p>
                Welcome to Elite Samskurti (&quot;we&quot;, &quot;our&quot;, or
                &quot;the Service&quot;). By accessing or using our matrimony
                services application, website, and related services
                (collectively, the &quot;Service&quot;), you agree to be bound
                by these Terms and Conditions (&quot;Terms&quot;). Please read
                these Terms carefully before using the Service.
              </p>

              <h6>Compliance with Indian Law</h6>
              <p>
                These Terms are governed by and construed in accordance with the
                laws of India, including but not limited to the Indian Contract
                Act, 1872, the Information Technology Act, 2000, and other
                applicable Indian laws and regulations.
              </p>

              <h6>Eligibility</h6>
              <ul>
                <li>
                  <p>
                    You must be at least 21 years old (for males) or 18 years
                    old (for females) in accordance with the legal marriageable
                    age in India, or as applicable under your personal law.
                  </p>
                </li>
                <li>
                  <p>
                    You must be legally free to marry and not prohibited from
                    entering into a matrimonial relationship under the laws
                    applicable to you in India.
                  </p>
                </li>
                <li>
                  <p>
                    You must have the legal capacity to enter into a binding
                    agreement.
                  </p>
                </li>
                <li>
                  <p>
                    We reserve the right to verify your age and identity at any
                    time, including by requesting government-issued
                    identification documents.
                  </p>
                </li>
              </ul>

              <h6>Registration and Account</h6>
              <ul>
                <li>
                  <p>
                    You must provide accurate, current, and complete information
                    during the registration process.
                  </p>
                </li>
                <li>
                  <p>
                    You may be required to provide certain identity verification
                    documents such as Aadhaar Card, PAN Card, or other
                    government-issued identification.
                  </p>
                </li>
                <li>
                  <p>
                    You are responsible for maintaining the confidentiality of
                    your account credentials.
                  </p>
                </li>
                <li>
                  <p>
                    You are solely responsible for all activities that occur
                    under your account.
                  </p>
                </li>
                <li>
                  <p>
                    You agree to notify us immediately of any unauthorized use
                    of your account.
                  </p>
                </li>
                <li>
                  <p>
                    We reserve the right to suspend or terminate your account if
                    any provided information is found to be inaccurate,
                    outdated, or incomplete.
                  </p>
                </li>
                <li>
                  <p>
                    You may be required to provide a valid Indian mobile number
                    for verification purposes.
                  </p>
                </li>
              </ul>

              <h6>Profile Creation and Content</h6>
              <ul>
                <li>
                  <p>
                    You are solely responsible for the content you publish on
                    your profile, including photos, personal information, and
                    preferences.
                  </p>
                </li>
                <li>
                  <p>
                    You grant us a non-exclusive, transferable, sub-licensable,
                    royalty-free, worldwide license to host, use, distribute,
                    modify, run, copy, publicly display, translate, and create
                    derivative works of your content in connection with the
                    operation of the Service.
                  </p>
                </li>
                <li>
                  <p>You agree not to post content that:</p>
                  <ul>
                    <li>
                      <p>Is false, misleading, or deceptive</p>
                    </li>
                    <li>
                      <p>Infringes on the rights of others</p>
                    </li>
                    <li>
                      <p>
                        Is illegal, obscene, defamatory, threatening, or
                        discriminatory
                      </p>
                    </li>
                    <li>
                      <p>Contains viruses or malicious code</p>
                    </li>
                    <li>
                      <p>Promotes illegal activities</p>
                    </li>
                    <li>
                      <p>
                        Hurts religious sentiments or promotes religious hatred
                      </p>
                    </li>
                    <li>
                      <p>Is against public policy or national interests</p>
                    </li>
                  </ul>
                </li>
                <li>
                  <p>
                    We reserve the right to remove any content that violates
                    these Terms or is otherwise objectionable at our sole
                    discretion.
                  </p>
                </li>
              </ul>

              <h6>User Conduct</h6>
              <p>You agree not to:</p>
              <ul>
                <li>
                  <p>
                    Use the Service for any illegal purpose or in violation of
                    any Indian laws.
                  </p>
                </li>
                <li>
                  <p>Harass, abuse, or harm another person.</p>
                </li>
                <li>
                  <p>Impersonate any person or entity.</p>
                </li>
                <li>
                  <p>
                    Use the Service for commercial solicitation or dowry
                    demands.
                  </p>
                </li>
                <li>
                  <p>
                    Attempt to access accounts or data that you are not
                    authorized to access.
                  </p>
                </li>
                <li>
                  <p>
                    Interfere with or disrupt the Service or servers or networks
                    connected to the Service.
                  </p>
                </li>
                <li>
                  <p>
                    Use automated scripts, bots, or scrapers to collect
                    information from the Service.
                  </p>
                </li>
                <li>
                  <p>
                    Create multiple accounts for deceptive or fraudulent
                    purposes.
                  </p>
                </li>
                <li>
                  <p>
                    Post obscene or vulgar content as prohibited under the
                    Information Technology Act, 2000.
                  </p>
                </li>
                <li>
                  <p>
                    Engage in any activity that may be considered a cognizable
                    offense under Indian law.
                  </p>
                </li>
              </ul>

              <h6>Dowry Prohibition</h6>
              <ul>
                <li>
                  <p>
                    In accordance with the Dowry Prohibition Act, 1961, our
                    Service strictly prohibits:
                  </p>
                </li>
                <ul>
                  <li>
                    <p>
                      Any requests for dowry or gifts as a condition for
                      marriage.
                    </p>
                  </li>
                  <li>
                    <p>
                      Advertisements or communications that directly or
                      indirectly suggest dowry requirements.
                    </p>
                  </li>
                  <li>
                    <p>
                      Any form of harassment or discrimination related to dowry
                      demands.
                    </p>
                  </li>
                </ul>
                <li>
                  <p>
                    Violations of these prohibitions may result in immediate
                    termination of your account and may be reported to
                    appropriate legal authorities.
                  </p>
                </li>
              </ul>

              <h6>Privacy and Data Protection</h6>
              <ul>
                <li>
                  <p>
                    Our Privacy Policy, incorporated by reference into these
                    Terms, explains how we collect, use, and protect your
                    personal information.
                  </p>
                </li>
                <li>
                  <p>
                    By using the Service, you consent to the collection and use
                    of your information as described in our Privacy Policy.
                  </p>
                </li>
                <li>
                  <p>
                    You acknowledge that while we implement reasonable security
                    measures in accordance with the Information Technology
                    (Reasonable Security Practices and Procedures and Sensitive
                    Personal Data or Information) Rules, 2011, no system can
                    guarantee complete security.
                  </p>
                </li>
              </ul>

              <h6>Safety Guidelines</h6>
              <ul>
                <li>
                  <p>We strongly recommend that you:</p>
                  <ul>
                    <li>
                      <p>
                        Meet in public places when meeting a match for the first
                        time.
                      </p>
                    </li>
                    <li>
                      <p>
                        Inform a friend or family member about your meeting
                        details.
                      </p>
                    </li>
                    <li>
                      <p>Arrange your own transportation.</p>
                    </li>
                    <li>
                      <p>
                        Be cautious about sharing personal or financial
                        information.
                      </p>
                    </li>
                    <li>
                      <p>Report suspicious behavior to us immediately.</p>
                    </li>
                  </ul>
                </li>
                <li>
                  <p>
                    We are not responsible for any offline interactions between
                    users.
                  </p>
                </li>
              </ul>
              {/* Add other sections similarly */}
              <h6>Verification and Background Checks</h6>
              <ul>
                <li>
                  <p>
                    We may offer optional verification or background check
                    services.
                  </p>
                </li>
                <li>
                  <p>
                    You acknowledge that verification processes may not be
                    comprehensive and have limitations.
                  </p>
                </li>
                <li>
                  <p>
                    We do not guarantee the accuracy of verification results or
                    the conduct of verified users.
                  </p>
                </li>
                <li>
                  <p>
                    You agree not to rely solely on verification badges or
                    similar indicators when making decisions.
                  </p>
                </li>
                <li>
                  <p>
                    Verification may include checks against publicly available
                    records or verification of documents like Aadhaar, PAN, or
                    other government IDs.
                  </p>
                </li>
              </ul>

              <h6>Intellectual Property</h6>
              <ul>
                <li>
                  <p>
                    The Service and its original content, features, and
                    functionality are owned by Elite Samskruti Matrimony and are
                    protected by Indian copyright, trademark, patent, trade
                    secret, and other intellectual property laws.
                  </p>
                </li>
                <li>
                  <p>
                    You may not copy, modify, create derivative works from,
                    publicly display, republish, or distribute any material from
                    our Service without prior written consent.
                  </p>
                </li>
              </ul>

              <h6>Subscription and Payment</h6>
              <ul>
                <li>
                  <p>
                    The Service may offer subscription plans with different
                    features and pricing.
                  </p>
                </li>
                <li>
                  <p>
                    Payment terms will be clearly disclosed before you complete
                    a purchase.
                  </p>
                </li>
                <li>
                  <p>
                    Subscriptions renew automatically until canceled by you.
                  </p>
                </li>
                <li>
                  <p>
                    Payments may be processed through authorized Indian payment
                    gateways and will be in Indian Rupees (INR).
                  </p>
                </li>
                <li>
                  <p>
                    All applicable taxes, including GST, will be charged as per
                    Indian tax regulations.
                  </p>
                </li>
                <li>
                  <p>
                    Refunds will be processed in accordance with our Refund
                    Policy and Indian consumer protection laws.
                  </p>
                </li>
                <li>
                  <p>
                    We reserve the right to modify pricing with reasonable
                    notice.
                  </p>
                </li>
              </ul>

              <h6>Termination</h6>
              <ul>
                <li>
                  <p>
                    We may suspend or terminate your access to the Service for
                    any violation of these Terms.
                  </p>
                </li>
                <li>
                  <p>
                    You may terminate your account at any time by following the
                    instructions on the Service.
                  </p>
                </li>
                <li>
                  <p>
                    Upon termination, your right to use the Service will
                    immediately cease.
                  </p>
                </li>
                <li>
                  <p>
                    All provisions of the Terms which by their nature should
                    survive termination shall survive, including ownership
                    provisions, warranty disclaimers, indemnity, and limitations
                    of liability.
                  </p>
                </li>
              </ul>

              <h6>Disclaimer of Warranties</h6>
              <ul>
                <li>
                  <p>
                    THE SERVICE IS PROVIDED &quot;AS IS&quot; AND &quot;AS
                    AVAILABLE&quot; WITHOUT WARRANTIES OF ANY KIND.
                  </p>
                </li>
                <li>
                  <p>
                    WE EXPLICITLY DISCLAIM ALL WARRANTIES, WHETHER EXPRESS,
                    IMPLIED, OR STATUTORY.
                  </p>
                </li>
                <li>
                  <p>WE DO NOT GUARANTEE THAT:</p>
                  <ul>
                    <li>
                      <p>THE SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE</p>
                    </li>
                    <li>
                      <p>DEFECTS WILL BE CORRECTED</p>
                    </li>
                    <li>
                      <p>
                        THE SERVICE OR SERVER ARE FREE OF VIRUSES OR OTHER
                        HARMFUL COMPONENTS
                      </p>
                    </li>
                    <li>
                      <p>YOU WILL FIND A SUITABLE MATCH THROUGH OUR SERVICE</p>
                    </li>
                  </ul>
                </li>
                <li>
                  <p>
                    THESE DISCLAIMERS ARE MADE TO THE EXTENT PERMITTED BY
                    APPLICABLE INDIAN LAW.
                  </p>
                </li>
              </ul>

              <h6>Limitation of Liability</h6>
              <ul>
                <li>
                  <p>
                    TO THE MAXIMUM EXTENT PERMITTED BY INDIAN LAW, WE SHALL NOT
                    BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
                    CONSEQUENTIAL, OR PUNITIVE DAMAGES.
                  </p>
                </li>
                <li>
                  <p>
                    OUR TOTAL LIABILITY TO YOU FOR ANY CLAIMS SHALL NOT EXCEED
                    THE AMOUNT YOU HAVE PAID TO US IN THE LAST SIX MONTHS.
                  </p>
                </li>
                <li>
                  <p>
                    WE ARE NOT LIABLE FOR ANY CONTENT POSTED BY USERS OR THE
                    CONDUCT OF USERS, WHETHER ONLINE OR OFFLINE.
                  </p>
                </li>
                <li>
                  <p>
                    THESE LIMITATIONS WILL APPLY TO THE EXTENT PERMITTED BY
                    APPLICABLE INDIAN LAW.
                  </p>
                </li>
              </ul>

              <h6>Indemnification</h6>
              <p>
                You agree to indemnify, defend, and hold harmless Elite
                Samskruti Matrimony, its affiliates, officers, directors,
                employees, and agents from any claims, liabilities, damages,
                losses, costs, expenses, or fees (including reasonable
                attorneys&apos; fees) arising from your use of the Service, your
                violation of these Terms, or your violation of any rights of
                another.
              </p>

              <h6>Governing Law and Dispute Resolution</h6>
              <ul>
                <li>
                  <p>
                    These Terms shall be governed by and construed in accordance
                    with the laws of India.
                  </p>
                </li>
                <li>
                  <p>
                    Any dispute arising from these Terms shall first be
                    attempted to be resolved through mutual negotiation.
                  </p>
                </li>
                <li>
                  <p>
                    If the dispute cannot be resolved through negotiation within
                    30 days, it shall be submitted to mandatory, binding
                    arbitration in accordance with the Arbitration and
                    Conciliation Act, 1996 of India.
                  </p>
                </li>
                <li>
                  <p>
                    The arbitration shall be conducted in [Your City], India, by
                    a sole arbitrator appointed by mutual consent.
                  </p>
                </li>
                <li>
                  <p>
                    The arbitration proceedings shall be conducted in English.
                  </p>
                </li>
                <li>
                  <p>
                    The arbitrator&apos;s decision shall be final and binding
                    and may be entered as a judgment in any court of competent
                    jurisdiction in India.
                  </p>
                </li>
                <li>
                  <p>
                    You agree that any claim must be brought within one year
                    after the cause of action arises.
                  </p>
                </li>
              </ul>

              <h6>Consumer Grievance</h6>
              <ul>
                <li>
                  <p>
                    In accordance with the Consumer Protection Act, 2019, we
                    provide mechanisms for addressing consumer grievances.
                  </p>
                </li>
                <li>
                  <p>
                    You may contact our designated Consumer Grievance Officer at
                    info@samskrutimatrimony.com.
                    {/* at +91 XXXXXXXXXX. */}
                  </p>
                </li>
                <li>
                  <p>
                    We will acknowledge your grievance within 48 hours and
                    resolve it within a reasonable timeframe.
                  </p>
                </li>
              </ul>

              <h6>Changes to Terms</h6>
              <ul>
                <li>
                  <p>We reserve the right to modify these Terms at any time.</p>
                </li>
                <li>
                  <p>
                    We will provide notice of significant changes through the
                    Service or by sending you an email.
                  </p>
                </li>
                <li>
                  <p>
                    Your continued use of the Service after such modifications
                    constitutes your acceptance of the revised Terms.
                  </p>
                </li>
              </ul>

              <h6>Severability</h6>
              <p>
                If any provision of these Terms is found to be unenforceable or
                invalid under Indian law, that provision will be limited or
                eliminated to the minimum extent necessary, and the remaining
                provisions will continue in full force and effect.
              </p>

              <h6>Entire Agreement</h6>
              <p>
                These Terms, together with the Privacy Policy and any other
                legal notices published by us, constitute the entire agreement
                between you and us concerning the Service.
              </p>

              <h6>Contact Information</h6>
              <ul>
                <li>
                  <p>
                    If you have any questions about these Terms, please contact
                    us at:
                  </p>
                </li>
                <ul>
                  <li>
                    <p>
                      <b>Email:</b>
                      <a
                        href="mailto:info@samskrutimatrimony.com"
                        style={{ marginLeft: '4px' }}
                      >
                        info@samskrutimatrimony.com
                      </a>
                    </p>
                  </li>
                  {/* <li>
                    <p>
                      <b>Address:</b> Hyderabad
                    </p>
                  </li> */}
                  {/* <b>Address:</b> Villa: 217, S T B L, Lakshmi Manohara
                      Gardens, Duvvada, Visakhapatnam, Visakhapatnam - 530046,
                      Andhra Pradesh */}
                  {/* <li>
                    <p>
                      <b>Phone:</b> +91 XXXXXXXXXX
                    </p>
                  </li> */}
                </ul>
              </ul>

              <p>
                <strong>Last Updated:</strong> 10th March 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
